import { render, staticRenderFns } from "./teachingCenterDialog.vue?vue&type=template&id=11067e28&scoped=true"
import script from "./teachingCenterDialog.vue?vue&type=script&lang=js"
export * from "./teachingCenterDialog.vue?vue&type=script&lang=js"
import style0 from "./teachingCenterDialog.vue?vue&type=style&index=0&id=11067e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11067e28",
  null
  
)

export default component.exports